import React from 'react';
import { EnumWidgetId } from '../../@types/Widget';
import { WidgetExecuteBatchResponseItem } from '../../@types/WidgetExecuteBatch';
import { CapitalizeFirstCharacter } from '../../utils/Helpers';
import WidgetValidator from './WidgetValidator';


export default function NewZealandIRDValidator() {
    return (
        <WidgetValidator
            widgetId={EnumWidgetId.NEW_ZEALAND_IRD_VALIDATOR}
            labelText="New Zealand IRD"
            prepareExecutePayload={(value) => ({ ird: value })}
            getAdditionalInfoNodes={getAdditionalInfoNodes}
        />
    )
}

function getAdditionalInfoNodes(batchItem?: WidgetExecuteBatchResponseItem) {
    if (!batchItem) {
        return null;
    }

    if (batchItem?.data?.valid) {
        return (
            <div className="text-gray-500 text-sm">
                <p className="pb-3">
                    <span className="font-bold text-green-500">{batchItem.data?.ird}</span> is a valid New Zealand IRD.
                </p>
                <p className="pb-3">
                    The last number ({batchItem?.data?.ird?.slice(-1)}) is used as a check digit to ensure that the IRD is valid.
                </p>
            </div>
        );
    }

    return (
        <div className="text-gray-500 text-sm">
            <p className="pb-3">
                <span className="font-bold text-red-500">{batchItem.data?.originalIRD || "''"}</span> is an invalid New Zealand IRD.
            </p>
            {batchItem.messages.map((message, index) => (
                message.message ? (
                    <p className="disc" key={`message-${index}`}>
                        {CapitalizeFirstCharacter(message.message)}
                    </p>
                ) : null
            ))}
        </div>
    )
}